import React from 'react';

export type ColorMode = 'light' | 'dark';

const STORAGE_KEY = 'ledium:colorMode';

function readStoredMode(): ColorMode {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
}

interface ColorModeContextValue {
    colorMode: ColorMode;
    toggleColorMode: () => void;
}

export const ColorModeContext = React.createContext<ColorModeContextValue>({
    colorMode: 'light',
    toggleColorMode: () => undefined
});

export function ColorModeProvider({ children }: { children: React.ReactNode }) {
    const [colorMode, setColorMode] = React.useState<ColorMode>(readStoredMode);

    const toggleColorMode = React.useCallback(() => {
        setColorMode((prev) => {
            const next: ColorMode = prev === 'light' ? 'dark' : 'light';
            localStorage.setItem(STORAGE_KEY, next);
            return next;
        });
    }, []);

    const value = React.useMemo(() => ({ colorMode, toggleColorMode }), [colorMode, toggleColorMode]);

    return <ColorModeContext.Provider value={value}>{children}</ColorModeContext.Provider>;
}

export function useColorMode(): ColorModeContextValue {
    return React.useContext(ColorModeContext);
}
